<template>
    <div class="cell" @click="handleClick">
        <slot name="left-icon"></slot>
        <div class="cell__left-icon"></div>
        <div class="cell__title" :style="titleStyle">{{title}}</div>
        <div class="cell__value" :style="valueStyle" :class="{'cell-placeholder': !value}">{{value || placeholder}}</div>
        <slot name="right-icon">
            <div v-show="isLink" class="cell__right-icon"></div>
        </slot>
    </div>
</template>

<script>
    export default {
        name: "Cell",
        props: {
            title: String,
            value: String,
            isLink: Boolean,
            placeholder: {
                type: String,
                default: ''
            },
            valueStyle: {
                type: Object,
                default: () => {return {}}
            },
            titleStyle: {
                type: Object,
                default: () => {return {}}
            }
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>

<style scoped lang="scss">
.cell {
    display: flex;
    flex-direction: row;
    font-size: 0.41rem;
    padding: 0 0.32rem;
    height: 1.33rem;
    line-height: 1.33rem;
    align-items: center;
    transition: background-color 300ms;

    &:not(:last-child) {
        border-bottom: 1px solid #e5e5e5;
    }

    &:active {
        background-color: #f2f3f5;
    }

    &__title {
        flex: 1;
    }
    &__value {
        flex: 1;
        text-align: right;
        &.cell-placeholder{
            color: #A6A6A6;
        }
    }
    &__right-icon {
        margin-left: 0.39rem;
        &::after {
            content: '';
            display: block;
            width: 0.21rem;
            height: 0.39rem;
            background: url('../../../assets/arrow-line.png') center / 100% no-repeat;
        }
    }
}
</style>
